import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { CopilotMotivation } from './copilotMotivation';
import { LearnMoreCard } from './learnMoreCard';

export const SettingsCopilotTrialFeaturesLearnMore = (): JSX.Element => {
  return (
    <>
      <Text.Paragraph>
        The Agent Co-pilot bundle empowers your team with cutting edge AI
        features, optimizing customer interactions
      </Text.Paragraph>
      <FlexBox flexDirection="row" gap="300" padding="400 0 400 0">
        <LearnMoreCard
          title="Smart Replies"
          description="Boost efficiency with AI + Knowledge base."
          icon="autocomplete"
          learnMoreLink="https://support.dixa.help/en/articles/1551-smart-conversation-replies"
        />
        <LearnMoreCard
          title="Smart Summaries"
          description="Get to the heart of every interaction quickly."
          icon="list-ul"
          learnMoreLink="https://support.dixa.help/en/articles/1616-smart-conversation-summaries"
        />
        <LearnMoreCard
          title="Smart Translations"
          description="Break down language barriers effort."
          icon="translate"
          learnMoreLink="https://support.dixa.help/en/articles/1702-ai-translations"
        />
        <LearnMoreCard
          title="AI Spellchecker"
          description="Perfect your writing effortlessly with advanced AI."
          icon="grammar-spelling"
          learnMoreLink="https://support.dixa.help/en/articles/1709-ai-spellchecker"
        />
        <LearnMoreCard
          title="Improve Reply"
          description="Communicate with precision, and on the tone."
          icon="pen"
          learnMoreLink="https://support.dixa.help/en/articles/1736-improve-reply"
        />
      </FlexBox>
      <CopilotMotivation />
    </>
  );
};
